/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/button/css/button';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '@swisslife/patterns-base/src/atoms/image/css/image';
import '@swisslife/patterns-base/src/atoms/link/css/link';
import '@swisslife/patterns-base/src/atoms/svg/css/svg';
import '@swisslife/patterns-base/src/atoms/text/css/text';

import './marketing-teaser.scss';
import './modifier/marketing-theme.scss';
